const {
  concat,
  filter,
  forEach,
  isEmpty,
  tap,
} = require('ramda')
const { Future } = require('ramda-fantasy')
const { curry } = require('yafu')

function dispatcherGetAll (streams, requestFn, predicate) {
  const requestedValues = new Set()

  return (wantedValues) => {
    const fromCache = []
    const toRequest = []

    forEach((value) => {
      if (requestedValues.has(value)) {
        fromCache.push(value)
      } else {
        toRequest.push(value)
      }
    }, wantedValues)

    const cachedResult = !isEmpty(fromCache)
      ? filter(predicate(fromCache), streams.main.extract())
      : []

    if (isEmpty(toRequest)) {
      return Future.of(cachedResult)
    }
    return requestFn(toRequest)
      .map(tap(streams.addAll.put))
      .map((result) => {
        forEach(requestedValues.add.bind(requestedValues), toRequest)
        return concat(result, cachedResult)
      })
  }
}

module.exports = curry(dispatcherGetAll)
